module.exports = __webpack_public_path__ + "media/pages/book/components/images/app-reviews/de/ines-af8478464e3d7634db82058bcc91489d.jpg";